import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useUserContext } from "../contexts/users-context";
import { URL } from "../hooks/fetchdata";
import { Spinner } from "react-bootstrap";
import Modal from '@mui/material/Modal';

// Icons
import 'boxicons/css/boxicons.min.css';

// SCSS
import "./home-videos-inner.scss";

// Images
import star from '../assets/images/star.png';
import emptyStar from '../assets/images/emptyStar.png';
import shareImage from '../assets/images/courseAbout/shareImage.png';
import bookmarkImage from '../assets/images/courseAbout/bookmark.png';
import done from '../assets/images/courseAbout/Done.png';

const HomeVideosInner = ({ handleOpen, setVideoSrc }) => {
  const { videoId } = useParams();  
  const { token, setLoading, loading } = useUserContext();
  const [course, setCourse] = useState(null);
  const [playlistVideos, setPlaylistVideos] = useState([]);
  const [accessToken, setAccessToken] = useState(false);
  const [openSections, setOpenSections] = useState([]);

  useEffect(() => {
    const userToken = localStorage.getItem('accessToken');
    setAccessToken(!!userToken);
  }, []);

  // Kurs ma'lumotlarini olish
  useEffect(() => {
    const fetchCourseData = async () => {
      if (!videoId) return;
      
      setLoading(true);
      try {
        // Barcha kurslarni olish
        const response = await fetch(`${URL}/api/courses/`, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        
        const data = await response.json();
        
        // Berilgan videoId bo'yicha kursni topish
        const foundCourse = data.find(course => 
            String(course.guid) === String(videoId)
         );

        
        if (foundCourse) {
          setCourse(foundCourse);
          setPlaylistVideos(foundCourse.videos || []);
          console.log("Topilgan kurs:", foundCourse);
        } else {
          console.error("Kurs topilmadi");
        }
      } catch (error) {
        console.error("Xatolik:", error);
      } finally {
      }
    };
    setLoading(false);

    fetchCourseData();
  }, [videoId, setLoading]);

  const toggleSection = (index) => {
    setOpenSections(prev => 
      prev.includes(index) 
        ? prev.filter(i => i !== index)
        : [...prev, index]
    );
  };

  // Vaqt formatlash (agar duration_seconds bo'lsa)
  const formatDuration = (seconds) => {
    if (!seconds) return null;
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  if (loading) {
    return (
      <div className="loading-container">
        <Spinner />
        <p>Kurslar yuklanmoqda...</p>
      </div>
    );
  }
  
  if (!course) {
    return (
      <div className="not-found">
        <h3>Kurs topilmadi</h3>
      </div>
    );
  }

  return (
    <div className="videos-card mb-3">
      <div className="doubleContainer">
        <div className="first">
          {/* Kurs haqida ma'lumot */}
          <div 
            className="aboutContainer" 
            style={{ 
              backgroundImage: `url(${course.thumbnail_url || 'sa'})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          >
            <div className="courseHeading">
              <div>
                <h2>{course.title}</h2>
                <div className="courseDescription">
                  <p>{course.description || "Bu kurs haqida ma'lumot yo'q"}</p>
                </div>
              </div>
            </div>
            
            <div className="starAndView">
              <div className="courseStars">
                <img src={star} alt="star" />
                <img src={star} alt="star" />
                <img src={star} alt="star" />
                <img src={star} alt="star" />
                <img src={emptyStar} alt="empty star" />
              </div>
              <span>
                4.0 • {course.video_count || 0} ta video
              </span>
            </div>
            
            <div className="threeInOne">
              <div>
                {accessToken ? (
                  <Link to="#">
                    Davom etish
                  </Link>
                ) : (
                  <Link to="/login">
                    Xisobga kirish
                  </Link>
                )}
              </div>
              <div>
                <Link to="#">
                  <img src={shareImage} alt="share" />
                </Link>
              </div>
              <div>
                <Link to="#">
                  <img src={bookmarkImage} alt="bookmark" />
                </Link>
              </div>
            </div>
          </div>

          {/* Video playlist */}
          <div className="courseDuration">
            <ul className="faq">
              {/* Kurs videolari */}
              {playlistVideos.length > 0 ? (
                <li>
                  <div className="q" onClick={() => toggleSection(0)}>
                    <span>Kurs videolari ({playlistVideos.length})</span>
                    <span className={`arrow ${openSections.includes(0) ? 'arrow-rotated' : ''}`}>
                      <i className='bx bx-chevron-down'></i>
                    </span>
                  </div>
                  <div className={`a ${openSections.includes(0) ? 'a-opened' : ''}`}>
                    {playlistVideos.map((video, idx) => (
                      <Link 
                        to="#" 
                        key={video.guid || idx}
                        onClick={() => { 
                          setVideoSrc(`https://www.youtube.com/embed/${video.youtube_video_id}`); 
                          handleOpen(); 
                        }}
                      >
                        <div className="video-item">
                          <div className="video-info">
                            <span className="video-number">{idx + 1}</span>
                            <div className="video-details">
                              <p className="video-title">{video.title}</p>
                              {video.duration_seconds && (
                                <span className="video-duration">
                                  {formatDuration(video.duration_seconds)}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>
                </li>
              ) : (
                <li className="no-videos">
                  <p>Bu kursda hali videolar mavjud emas</p>
                </li>
              )}

              {/* Testlar (agar mavjud bo'lsa) */}
              {accessToken && (
                <div id="testCc">
                  {/* Testlar ma'lumotlari kelganda qo'shiladi */}
                </div>
              )}
            </ul>
          </div>

          {/* Kurs haqida batafsil */}
          <div className="aboutLessons">
            <h3>Ushbu kurs haqida</h3>
            <div className="moreLessons">
              <p>
                <img src={done} alt="done" /> 
                Video soni: {course.video_count || 0}
              </p>
              <p>
                <img src={done} alt="done" /> 
                Qo'shilgan sana: {new Date(course.created_at).toLocaleDateString('uz-UZ')}
              </p>
              {course.description && (
                <p>
                  <img src={done} alt="done" /> 
                  {course.description}
                </p>
              )}
            </div>
          </div>
        </div>

        {/* Reyting qismi */}
        <div className="second">
          <div className="rating">
            <h1>4.2</h1>
            <div>
              <div className="ratingStars">
                <div className="courseStars">
                  <img src={star} alt="star" />
                  <img src={star} alt="star" />
                  <img src={star} alt="star" />
                  <img src={star} alt="star" />
                  <img src={emptyStar} alt="empty star" />
                </div>
              </div>
            </div>
          </div>
          
          <div className="ratingContainer">
            <div className="ratingLine">
              <img src={star} alt="star" /> 5
              <div className="line">
                <span style={{width: '100%'}}></span>
              </div>
              100%
            </div>
            <div className="ratingLine">
              <img src={star} alt="star" /> 4
              <div className="line">
                <span style={{width: '80%'}}></span>
              </div>
              80%
            </div>
            <div className="ratingLine">
              <img src={star} alt="star" /> 3
              <div className="line">
                <span style={{width: '60%'}}></span>
              </div>
              60%
            </div>
            <div className="ratingLine">
              <img src={star} alt="star" /> 2
              <div className="line">
                <span style={{width: '40%'}}></span>
              </div>
              40%
            </div>
            <div className="ratingLine">
              <img src={star} alt="star" /> 1
              <div className="line">
                <span style={{width: '20%'}}></span>
              </div>
              20%
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const DashboardVideoCard = () => {
  const [open, setOpen] = useState(false);
  const [videoSrc, setVideoSrc] = useState("");
  
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <div className="dashboard-video-card">
        <div className="img">
          <HomeVideosInner 
            handleOpen={handleOpen} 
            setVideoSrc={setVideoSrc} 
          />
        </div>
      </div>
      
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="video-modal"
        aria-describedby="video-player"
      >
        <div className="youtube-container">
          {videoSrc && (
            <iframe 
              width="100%" 
              height="100%" 
              src={videoSrc} 
              title="YouTube video player" 
              frameBorder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
              referrerPolicy="strict-origin-when-cross-origin" 
              allowFullScreen
            />
          )}
        </div>
      </Modal>
    </>
  );
};

export default DashboardVideoCard;